import { shape, bool, any, number } from 'prop-types';

export const stateType = shape({
    fetching: bool,
    error: any,
    fetched: bool,
});

export const layoutType = shape({
    flexGrow: number, // Widget's proportion in its row
    stretch: bool, // To fill all vertical space
});

export const defaultLayout = {
    flexGrow: 1,
    stretch: false,
};
